import {
  FETCH_COMPANIES_BEGIN,
  FETCH_COMPANIES_SUCCESS,
  FETCH_COMPANIES_FAILURE,
  DELETE_COMPANY_BEGIN,
  DELETE_COMPANY_SUCCESS,
  DELETE_COMPANY_FAILURE
} from "../actions/Companies";

const initialState = {
  companies: [],
  loading: false,
  error: null,
};

export default function companiesReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_COMPANIES_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_COMPANIES_SUCCESS:
      return {
        ...state,
        loading: false,
        companies: action.payload,
      };

    case FETCH_COMPANIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        companies: [],
      };
    case DELETE_COMPANY_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case DELETE_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        companies: state.companies.filter((company) => company._id !== action.id),
      };

    case DELETE_COMPANY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
